import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CoffeeMachineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CoffeeMachineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.6753 4.8989H5.1753C4.85171 4.8989 4.58936 5.16124 4.58936 5.48484C4.58936 5.80844 4.8517 6.07078 5.1753 6.07078H7.6753C7.99889 6.07078 8.26124 5.80844 8.26124 5.48484C8.26124 5.16124 7.9989 4.8989 7.6753 4.8989Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5035 9.89891H18.8863V8.57079H20.1753C20.4989 8.57079 20.7613 8.30844 20.7613 7.98485V2.98484C20.7613 2.66125 20.4989 2.3989 20.1753 2.3989H2.6753C2.35171 2.3989 2.08936 2.66124 2.08936 2.98484V7.98485C2.08936 8.30843 2.3517 8.57079 2.6753 8.57079H3.96436V18.6489H3.9253C2.91295 18.6489 2.08936 19.4725 2.08936 20.4849V21.7349C2.08936 22.0585 2.3517 22.3208 2.6753 22.3208H20.1753C20.4989 22.3208 20.7613 22.0585 20.7613 21.7349V20.4849C20.7613 19.4725 19.9377 18.6489 18.9253 18.6489H18.8863V11.0708H21.5035C21.827 11.0708 22.0894 10.8084 22.0894 10.4848C22.0894 10.1612 21.8271 9.89891 21.5035 9.89891ZM17.7144 9.89891H14.1729L14.4143 8.57079H17.7144V9.89891ZM10.0393 10.8364L9.62743 8.57079H13.2233L12.8114 10.8364H10.0393ZM3.26124 3.57078H19.5894V7.39891H3.26124V3.57078ZM19.5894 20.4849V21.1489H3.26124V20.4849C3.26124 20.1187 3.55913 19.8208 3.9253 19.8208H18.9253C19.2915 19.8208 19.5894 20.1187 19.5894 20.4849ZM9.60118 16.0708H13.3276L13.1127 18.6489H9.81603L9.60118 16.0708ZM17.7144 18.6489H14.2887L14.3961 17.3599H15.5269C15.8505 17.3599 16.1128 17.0975 16.1128 16.7739C16.1128 16.4503 15.8505 16.188 15.5269 16.188H14.4938L14.5483 15.5335C14.5619 15.3702 14.5065 15.2087 14.3956 15.0882C14.2846 14.9676 14.1283 14.8989 13.9644 14.8989H8.96438C8.80051 14.8989 8.64415 14.9676 8.53321 15.0882C8.42227 15.2087 8.36688 15.3703 8.38048 15.5335L8.64009 18.6489H5.13626V8.57081H8.43634L8.97388 11.5272C9.02451 11.8058 9.26712 12.0083 9.55033 12.0083H10.8394V12.9849C10.8394 13.3085 11.1017 13.5708 11.4253 13.5708C11.7489 13.5708 12.0113 13.3085 12.0113 12.9849V12.0083H13.3003C13.5835 12.0083 13.8261 11.8058 13.8768 11.5272L13.9598 11.0708H17.7144L17.7144 18.6489Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1753 6.07078C15.4989 6.07078 15.7612 5.80844 15.7612 5.48484C15.7612 5.16123 15.4989 4.8989 15.1753 4.8989C14.8517 4.8989 14.5894 5.16123 14.5894 5.48484C14.5894 5.80844 14.8517 6.07078 15.1753 6.07078Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.6753 6.07078C17.9989 6.07078 18.2612 5.80844 18.2612 5.48484C18.2612 5.16123 17.9989 4.8989 17.6753 4.8989C17.3517 4.8989 17.0894 5.16123 17.0894 5.48484C17.0894 5.80844 17.3517 6.07078 17.6753 6.07078Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CoffeeMachineIcon;
